export default function isMouseInPort({mousePos, component, port}) {
    if(!component) {
        return false;
    }

    const portX = component.x + port.x * component.width;
    const portY = component.y + port.y * component.height;
    return Math.sqrt(Math.pow(mousePos.x - portX, 2) + Math.pow(mousePos.y - portY, 2)) <= 5;
}